module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-07.79bfbf1c.jpg";